import { AreaChart as BaseAreaChart } from "@mantine/charts"

import { Filters } from "@costory/types/filters"

import { tickFormatter } from "@costory/shared/utils/charts"
import { formatNumber } from "@costory/shared/utils/format"

import { ChartTooltip } from "@costory/front/components/charts/ChartTooltip"
import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { useExplorerQuery } from "@costory/front/queries/explore"
import { getCharteSerieColor } from "@costory/front/utils/charts"

type Props = {
  filters: Filters
  height?: number
  withLegend?: boolean
}

export const AreaChart = ({ filters, height, withLegend = true }: Props) => {
  const explorerQuery = useExplorerQuery(filters)
  return (
    <QueryWrapper query={explorerQuery}>
      {({ data }) => (
        <BaseAreaChart
          h={height ?? "100%"}
          pr="50px"
          data={data.stackedBarChartData.arr}
          xAxisProps={{
            angle: 30,
            height: 60,
            textAnchor: "start",
            tickFormatter: (val: string) => tickFormatter(val, filters.aggBy),
          }}
          dataKey="agg_date"
          withLegend={withLegend}
          curveType="linear"
          valueFormatter={(value) =>
            formatNumber({ value, currency: filters.currency })
          }
          series={data.stackedBarChartData.items.map((item, index) => ({
            name: item.name,
            color: getCharteSerieColor(index),
          }))}
          tooltipProps={{
            content: ({ label, payload, coordinate }) => (
              <ChartTooltip
                label={label}
                payload={
                  payload as {
                    name: string
                    value: number
                    dataKey: string
                  }[]
                }
                currency={filters.currency}
                coordinate={{
                  x: coordinate?.x ?? 0,
                }}
                aggBy={filters.aggBy}
              />
            ),
          }}
        />
      )}
    </QueryWrapper>
  )
}
